var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.864 25c6.828 0 12.364-5.597 12.364-12.5H.5C.5 19.403 6.035 25 12.864 25z",
    fill: "#60B6B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.864 12.5c6.828 0 12.364-5.596 12.364-12.5H.5c0 6.904 5.535 12.5 12.364 12.5z",
    fill: "#335280"
  })));
}
export default SvgLanguages;